import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { formatTotalTime } from '@frontend/unhideschool/modules/player/utils/player.utils';

@Component({
  selector: 'unh-video-box',
  templateUrl: './video-box.component.html',
  styleUrls: ['./video-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoBoxComponent {
  @Input() url: any;
  @Input() title: any;
  @Input() instrutor: any;
  @Input() link: any;
  @Input() free: boolean;
  @Input() totaltime: any;
  @Input() loading: boolean = false;


  imgLoaded: boolean = false;

  getBackgroundStyleFormated(url){
    return `url('${url}')`;
  }

  modifyDuration(totaltime) {
    return formatTotalTime({totaltime}, 'minutes')
  }
}
